function WebPaging({ total, limit, page, setPage }) {
  const numPages = Math.ceil(total / limit);
  return total > 10 ? (
    <div className="paging-btns">
      <button
        className="paging-left paging-first"
        onClick={() => setPage(1)}
        disabled={page === 1}
      >
      </button>
      <button
        className="paging-left"
        onClick={() => setPage(page - 1)}
        disabled={page === 1}
      >
      </button>
      <span>
        {Array(numPages)
          .fill()
          .map((_, i) => (
            <button
              className={page === i + 1 ? "paging-num on" : "paging-num"}
              key={i + 1}
              onClick={() => setPage(i + 1)}
              aria-current={page === i + 1 ? "page" : null}
            >
              {i + 1}
            </button>
          ))}
      </span>
      <button
        className="paging-right"
        onClick={() => setPage(page + 1)}
        disabled={page === numPages}
      >
      </button>
      <button
        className="paging-right paging-last"
        onClick={() => setPage(Math.max(numPages))}
        disabled={page === numPages}
      >
      </button>
    </div>
  ) : (
    <></>
  );
}

export default WebPaging;
